/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_ProposalInputs */

const en_header_proposal = /** @type {(inputs: Header_ProposalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal`)
};

/**
* | output |
* | --- |
* | "Proposal" |
*
* @param {Header_ProposalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_proposal = /** @type {((inputs?: Header_ProposalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_ProposalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_proposal(inputs)
});